import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";
import { enum_api_uri } from "common/hooks/utils/enum";
// import { useAuthStore } from "user/store/useAuthStore";

interface Request {
    m_category: number;
    m_email: string;
}

interface Response {
    data: null;
}

export const usePostSendPassword = (successCallback?: () => void): UseMutationResult<Response, Error, Request, unknown> => {
    // const setAuth = useAuthStore(state => state.setAuth);

    return useMutation<Response, Error, Request>({
        mutationFn: async ({ m_email, m_category }: Request) => {
            const response = await axios.post(enum_api_uri.user.post_send_password, {
                m_category,
                m_email,
            });
            return response.data;
        },
        onSuccess: data => {
            // const userData = data.data;
            successCallback?.();
        },
    });
};
